<!-- Password Protection Modal -->
<div class="modal fade" id="passwordModal" tabindex="-1" aria-labelledby="passwordModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark text-white border-secondary shadow-lg">
            <div class="modal-header border-secondary">
                <h5 class="modal-title fw-bold text-white d-flex align-items-center gap-2" id="passwordModalLabel">
                    <i class="bi bi-lock-fill text-warning fs-4"></i>
                    Password Protected Room
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                    (click)="onCancel()"></button>
            </div>
            <div class="modal-body text-white py-4 px-4">
                <div class="text-center mb-4">
                    <div class="bg-secondary bg-opacity-25 rounded-circle d-inline-flex p-3 mb-2">
                        <i class="bi bi-shield-lock text-warning" style="font-size: 2.5rem;"></i>
                    </div>
                    <h5 class="fw-bold mb-1 text-warning">{{ targetArena()?.title || 'Locked Room' }}</h5>
                    <p class="small text-muted mb-0">Please enter the password to join this room.</p>
                </div>

                <div class="form-floating mb-2">
                    <input type="password" class="form-control bg-dark text-white border-secondary" id="passwordModalInput"
                        placeholder="Enter Room Password" [value]="password()"
                        (input)="password.set($any($event.target).value)" (keydown.enter)="confirmJoin()" #passwordInput>
                    <label for="passwordModalInput" class="text-muted">Enter Password</label>
                </div>

                @if (errorMessage()) {
                <div class="small text-danger mt-2 d-flex align-items-center gap-1">
                    <i class="bi bi-exclamation-triangle-fill"></i>
                    <span>{{ errorMessage() }}</span>
                </div>
                }
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal" (click)="onCancel()">Cancel</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" [disabled]="!password().trim()" (click)="confirmJoin()">Join Room</button>
            </div>
        </div>
    </div>
</div>
